module.exports = __webpack_public_path__ + "statics/img/yhz2m.58e5f439.png";